
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";
import * as modals from "@/lib/modals";

@Component({
  name: modals.addTruckModal
})
export default class AddTruckModal extends Mixins(mixin) {
  newTrucks: AddTruckViewModel[] = [{ id: 1, added: false }];

  get invalid() {
    return this.newTrucks.filter(x => x.added).length < 1;
  }

  //sf - is this not built yet?

  show() {}

  resetModal() {}

  submit() {}
}

interface AddTruckViewModel {
  id: number;
  truckName?: string;
  deliveryDate?: Date;
  zipsServed?: string;
  driverName?: string;
  maxCubes?: number;
  tripDays?: number;
  facilityCode?: string;
  added: boolean;
}
